var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notice-form',{attrs:{"is-edit":"","data":_vm.noticeInfo},on:{"save":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }